export default __webpack_public_path__ + "static/media/users-monitor.ee58fde7.svg";